import {
  defaultCellRenderer as renderer,
  defaultGroupRenderer as groupRenderer
} from "../../utils/utils.jsx";
import { WIDGET_KEYS } from "../WidgetKeys.jsx";
import {customGroupByOrder, htmlEncode} from "../../utils/otherUtils.jsx";

export const CLIENT_VIEW_COLUMNS = [
  {
    id: "client-name",
    type: WIDGET_KEYS.columnEntityMainName,
    text: "Client",
    field: "name",
    region: "locked",
    width: "15em",

    headerMenuItems: {
      addNewEntity: {
        _menuId: "client",
        icon: "fa-plus",
        text: "New Client",
        weight: 10,
      },
    },
    groupRenderer,
  },
  { id: "client-contacts", type: WIDGET_KEYS.contactColumn },
  { id: "client-reminder-bell", type: WIDGET_KEYS.alertBellColumn, isAlertBell: true },
  { id: "client-checklist", type: WIDGET_KEYS.checklistColumn },
  { id: "client-notes", type: WIDGET_KEYS.notesColumn },
  { id: "client-media", type: WIDGET_KEYS.mediaColumn },
  { id: "client-documents", type: WIDGET_KEYS.documentsColumn },
  {
    id: "client-team",
    text: "Team", field: "teamValue",
    editor: false,
    type: WIDGET_KEYS.teamField,
    flex: 1,
    swivuListTitle: "Client Team",
    headerMenuItems: {
      columnItem: customGroupByOrder("teamId", "teamStore")
    }
  },
  {
    id: "client-address",
    text: "Address",
    field: "address",
    type: WIDGET_KEYS.swivuSortColumn,
    flex: 1,
    renderer,
    groupRenderer,
  },
  { id: "client-city", text: "City", field: "city", type: WIDGET_KEYS.swivuSortColumn, flex: 1, renderer, groupRenderer },
  { id: "client-aging", text: "Age", field: "aging", flex: 1, type: 'agingColumn', editor: false},
  {
    id: "client-website",
    text: "Website",
    field: "website",
    flex: 1,
    type: WIDGET_KEYS.swivuSortColumn,
    htmlEncode : false,
    editor: WIDGET_KEYS.fieldUrl,
    renderer: ({ value }) => value ? `<a href="${value}" target="_blank">${htmlEncode(value)}</a>`: renderer({ value: null }),
    groupRenderer,
  },
  {
    id: "client-status",
    text: "Status",
    field: "statusValue",
    flex: 1,
    type: WIDGET_KEYS.columnClientStatus,
    editor: false,
    headerMenuItems: {
      columnItem: customGroupByOrder("statusId", "tagStore")
    }
  },
  {
    id: "client-category",
    text: "Category",
    field: "categoryValue",
    flex: 1,
    type: WIDGET_KEYS.columnClientCategory,
    editor: false,
    headerMenuItems: {
      columnItem: customGroupByOrder("categoryId", "tagStore")
    }
  },
  {
    id: "client-tag",
    text: "Tags",
    field: "tagsValue",
    flex: 1,
    type: WIDGET_KEYS.columnClientTag,
    editor: false,
  },
];
